const skuToIgnoreCOD = ["50030873903397","50030896185637","50030896218405","50030896251173","50030896283941","50030896316709","50034852757797","50034852790565","50034852823333","50034852856101","50035211501861","50035211534629","50035211567397","50035211600165","50031416115493","50031418212645","50031418245413","50031418278181","50031418310949","50031418343717"]
const skuToAppendCOD = [] 

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};
